<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="mobile_responsive" style="display: none;">
      <div class="head">
        <div class="title">
          <div class="label">
            {{'INPLANT.inPlantVehicles'| translate}}
          </div>
          <!-- <div class="download_btn" (click)="download();">
            <img src="assets/download-icon-mobile.svg" alt="">
            <span class="download">{{'EXTERNALPARKINGVEHICLES.download'| translate}}</span>
          </div> -->
        </div>
        <div class="filter">
          <div class="all_unit">
            <div class="all_unit_title">
              {{'INPLANT.allUnit'| translate}}
            </div>
            <div class="all_unit_toggle">
              <mat-slide-toggle (change)="allUnitData()">
              </mat-slide-toggle>
            </div>
          </div>
          <div class="all_unit">
            <div class="all_unit_title">
              {{'EXTERNALPARKINGVEHICLES.advanceRegVehicles'| translate}}
            </div>
            <div class="all_unit_toggle">
              <mat-slide-toggle (change)="advanceRegVehicles()">
              </mat-slide-toggle>
            </div>
          </div>
          <!-- <div class="all_unit">
            <div class="all_unit_title">
              {{'EXTERNALPARKINGVEHICLES.doIssued'| translate}}
            </div>
            <div class="all_unit_toggle">
              <mat-slide-toggle (change)="doIssued()">
              </mat-slide-toggle>
            </div>
          </div> -->

          <div class="mobile_filters">
            <div class="mobile_filters">
              <div class="date_filter">
                <div class="input">
                  <div class="input-container">
                    <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')"
                      [(ngModel)]="vehicle_number" name="filter" placeholder="Vehicle No." type="text">
                    <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i
                        class="material-icons" id="material-icons-close">
                        clear
                      </i></span>
                  </div>
                </div>
              </div>
              <hr class="line">
              <div class="date_filter">
                <div class="input">

                  <div class="input-container" style="display: flex; align-items: center;">
                    <mat-select class="inputSelect" style="color: #fff;width: 120px;" [(ngModel)]="searchCarrier"
                      (selectionChange)="applyFilter(searchCarrier,'carrier')" placeholder="Carrier">
                      <mat-option *ngFor="let carrier of carriers" [value]="carrier._id">
                        {{carrier.carrierName}}
                      </mat-option>
                    </mat-select>
                    <span class="close_img" *ngIf="searchCarrier" (click)="clearCarrier()"><i class="material-icons"
                        id="material-icons-close">
                        clear
                      </i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top_header">
      <div class="item">
        <div class="label">
          {{'EXTERNALPARKINGVEHICLES.title'| translate}}
        </div>

      </div>
      <div class="item">
        <div class="count_display">
          <div class="count_show">
            <span class="label">{{'EXTERNALPARKINGVEHICLES.total_no_of_vehicles'| translate}}</span>
            <span class="count">{{totalvehicles}}</span>
          </div>
          <div class="count_show">
            <span class="label">{{'EXTERNALPARKINGVEHICLES.more_than_24'| translate}}</span>
            <span class="count">{{twentyfourhourscount}}</span>
          </div>
          <div class="count_show">
            <span class="label"> {{'EXTERNALPARKINGVEHICLES.more_than_48'| translate}}</span>
            <span class="count">{{fourtyeighthourscount}}</span>
          </div>
        </div>

      </div>
      <div class="item">
        <div class="refresh_btn">
          <mat-icon class="" style="cursor: pointer;" (click)="getExternalParkingVehicles()">refresh</mat-icon>
        </div>
      </div>
    </div>
    <div class="bottom_header">
      <div class="item">
        <!-- <div class="advance_search">
          <div class="advance_filter" (click)="openFilterDialog()">
            <div class="advance_title">Advance Search</div>
            <div class="filtericon">
              <img src="assets/filter-icon.svg" alt="">
            </div>
          </div>


          <div class="Report_dialog" *ngIf="showAdvanceFilter">
            <div class="header">
              <i class="material-icons" (click)="filtersDialogclose()">clear</i>
            </div>
            <div class="filtersection">
              <div class="filter_container">


                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Customer Name" [(ngModel)]="customerName">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Destination" [(ngModel)]="destination">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Vehicle No" [(ngModel)]="vehicleNumber">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Driver Name" [(ngModel)]="name">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Material" [(ngModel)]="material">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="OBD No" [(ngModel)]="doNum">
                  </div>
                </div>

                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Registration No" [(ngModel)]="registrationNumber">
                  </div>
                </div>
                <div class="left_sec">
                  <div class="input_select">
                    <input type="text" placeholder="Mobile No" [(ngModel)]="mobileNumber">
                  </div>
                </div>
                <div class="left_sec">
              

                  <mat-select class="inputSelect" style="color: #fff;" placeholder="Gps Provider" [(ngModel)]="gps"
                    style="color: #fff;border-radius: 4px;border: solid 1px #DFE3EB;
                padding: 9px;font-size: 13px;">
                    <mat-option *ngFor="let provider of gps_providers" [value]="provider.name">
                      {{provider.name}}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div class="clear_btn" (click)="clear();submitSearch();">Clear filter</div>
              <div class="submit_btn" (click)="submitSearch()">Search</div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="item all_unit_sec">
        <div>
          <mat-slide-toggle class="switch1" (change)="allUnitData()">
          </mat-slide-toggle>
          <span class="toggle">{{'EXTERNALPARKINGVEHICLES.allUnit'| translate}}</span>
        </div>
        <div>
          <mat-slide-toggle class="switch1" (change)="advanceRegVehicles()">
          </mat-slide-toggle>
          <span class="toggle">{{'EXTERNALPARKINGVEHICLES.advanceRegVehicles'| translate}}</span>
        </div>
        <!-- <div>
          <mat-slide-toggle class="switch1" (change)="doIssued()">
          </mat-slide-toggle>
          <span class="toggle">{{'EXTERNALPARKINGVEHICLES.doIssued'| translate}}</span>
        </div> -->
        <!-- <div class="download_sec" (click)="download();">
          <div> <img src="assets/download-icon-new.svg" alt=""> </div>
        </div> -->
        <div>

        </div>
      </div>
    </div>
    <!-- <div class="header">
      <div class="left">
        <div class="label">
          {{'EXTERNALPARKINGVEHICLES.title'| translate}}
        </div>
      </div>
      <div class="right">

        <div class="button" (click)="download();">
          <div class="downloadButton">
            {{'EXTERNALPARKINGVEHICLES.download'| translate}}
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="filters"> -->
    <!-- <div class="input" style="margin-right: 15px;">
        <span style="margin-right: 10px;">{{'EXTERNALPARKINGVEHICLES.allUnit'| translate}}</span>
        <mat-slide-toggle (change)="allUnitData()">
        </mat-slide-toggle>
      </div>
      <div class="input" style="margin-right: 15px;">
        <span style="margin-right: 10px;">{{'EXTERNALPARKINGVEHICLES.advanceRegVehicles'| translate}}</span>
        <mat-slide-toggle (change)="advanceRegVehicles()">
        </mat-slide-toggle>
      </div>
      <div class="input" style="margin-right: 15px;">
        <span style="margin-right: 10px;">{{'EXTERNALPARKINGVEHICLES.doIssued'| translate}}</span>
        <mat-slide-toggle (change)="doIssued()">
        </mat-slide-toggle>
      </div>

      <div class="search_sec">
        <div class="input-container">
          <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')" [(ngModel)]="vehicle_number"
            name="filter" placeholder="Vehicle No." type="text">
          <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i class="material-icons"
              id="material-icons-close">
              clear
            </i></span>
        </div>
      </div>

      <div class="search_sec">
        <div class="input-container" style="display: flex; align-items: center;">
          <mat-select class="inputSelect" style="color: #fff;width: 160px;" [(ngModel)]="searchCarrier"
            (selectionChange)="applyFilter(searchCarrier,'carrier')" placeholder="Carrier">
            <mat-option *ngFor="let carrier of carriers" [value]="carrier._id">
              {{carrier.carrierName}}
            </mat-option>
          </mat-select>
          <span class="close_img" *ngIf="searchCarrier" (click)="clearCarrier()"><i class="material-icons"
              id="material-icons-close">
              clear
            </i></span>
        </div>
      </div> -->
    <!-- <div class="filter">
                <div class="label">
                    {{ "REPORTS.from" | translate }}
                </div>
                <div class="input">
                    <input type="text" class="inputField" placeholder="Date" [(ngModel)]="fromDate"
                        (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
                    <mat-datepicker #fromDateInput3 (closed)="getExternalParkingVehicles()"></mat-datepicker>
                    <span class="material-icons dateIcon"> date_range </span>
                </div>
            </div>
            <div class="filter">
                <div class="label">
                    {{ "REPORTS.to" | translate }}
                </div>
                <div class="input">
                    <input type="text" class="inputField" placeholder="Date" [(ngModel)]="toDate"
                        (click)="toDateInput3.open()" [matDatepicker]="toDateInput3" />
                    <mat-datepicker #toDateInput3 (closed)="getExternalParkingVehicles()"></mat-datepicker>
                    <span class="material-icons dateIcon"> date_range </span>
                </div>
            </div> -->
    <!-- <div class="refresh_btn">
        <mat-icon class="" (click)="getExternalParkingVehicles()">refresh</mat-icon>
      </div> -->
    <!-- </div> -->



    <div class="body">

      <!-- <div class="chips_sec" *ngIf="AdvacnceFilterList && AdvacnceFilterList.length">
        <span class="total_count">{{totalvehicles}} result for :</span>

        <div *ngFor="let item of AdvacnceFilterList">
          <span class="search_heading"> {{item.name}} :</span>
          <span class="chip_gap">
            <mat-chip (removed)="remove(item)"> {{item.value}}<button matChipRemove class="chip_btn">
                <mat-icon class="close_chip">close</mat-icon>
              </button></mat-chip>
          </span>
        </div>
        <div class="clear_all" (click)="clear();submitSearch();">Clear All</div>
      </div> -->



      <div class="table">
        <table mat-table *ngIf="externalParkingvehicles && externalParkingvehicles.length;else noData"
          [dataSource]="externalParkingvehicles">

          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.sno'| translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
          </ng-container>

          <ng-container matColumnDef="regNo">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.regNo'| translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.regID}}
            </td>
          </ng-container>
          <ng-container matColumnDef="PlantConfirmation">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.Plant_Confirmation'| translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.plantConfirmationTime}} <br> {{element.vehicleCallTime}}
            </td>
          </ng-container>
          <ng-container matColumnDef="regDate">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.regDate'| translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.regTime}}
            </td>
          </ng-container>

          <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.vehicle'| translate}}
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="online_status">
                {{element.vehicle}}
                <div class="online_heart_beat" *ngIf="element.online"></div>
                <div class="offline_heart_beat" *ngIf="!element.online"></div>
              </div>
              {{element.gps_provider}}
            </td>
          </ng-container>

          <ng-container matColumnDef="driver">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.driver'| translate}}
            </th>
            <td mat-cell *matCellDef="let element"> <img src="assets/spotdriver-blue.svg" *ngIf="element.is_temporary"
                alt="" height="15px" width="15px" title="Spot Driver">
              {{element.name}} <br> {{element.mobile}} </td>
          </ng-container>

          <ng-container matColumnDef="capacity">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.capacity'|
              translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.loadQty}} <br> {{element.desiredWeight}} </td>
          </ng-container>

          <ng-container matColumnDef="carrier">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.carrier'| translate}}
              <img class="whatsapp" style="width: 17px;position: relative; top: 3px;" (click)="sortCarrier()"
                [src]="carrierSortIcon" alt="">
            </th>
            <td mat-cell *matCellDef="let element"> {{element.transp_name}} <br>
              <span
                [ngStyle]="{'color': element.transType === 'CT' ? '#2962Ff' : element.transType === 'PT' ? '#ed4747' : ''}">{{element.transType}}</span>
              <span style="cursor: pointer;" matTooltip="Copy to clipboard"
                *ngIf="(element.carrierUnit.erp_reference && element.carrierUnit.erp_reference.length >0) ? element.carrierUnit.erp_reference[element.carrierUnit.erp_reference.length-1].reference_id: ''"
                (click)="dummy(element.carrierUnit)">
                - {{(element.carrierUnit.erp_reference && element.carrierUnit.erp_reference.length >0) ?
                element.carrierUnit.erp_reference[element.carrierUnit.erp_reference.length-1].reference_id: ''}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="prefferedLocation">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.prefferedLocation'|
              translate}}
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.cust_name}} <br> {{element.destination}} </td>
          </ng-container>

          <ng-container matColumnDef="prefferedLoad">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.prefferedLoad'|
              translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.obdNumbers}} </td>
          </ng-container>

          <ng-container matColumnDef="material">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.material'|
              translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.material}} </td>
          </ng-container>

          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.remarks'| translate}}
            </th>
            <td mat-cell *matCellDef="let element" matTooltip={{element.remarks}}> {{element.remarks[0] || 'N/A'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.doStatus'|
              translate}} </th>
            <td mat-cell *matCellDef="let element"><span
                *ngIf="element.doStatus !== '[object Object]'">{{element.doStatus}}</span></td>
          </ng-container>

          <ng-container matColumnDef="currentgpslocation">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.currentgpslocation'|
              translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.gpsLoc}} </td>
          </ng-container>

          <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.age'| translate}}
              <img class="whatsapp" style="width: 17px;position: relative; top: 3px;" (click)="sortVehicleAgeing()"
                [src]="vehicleAgeingSortIcon" alt="">
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.aging}} </td>
          </ng-container>

          <!-- <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'EXTERNALPARKINGVEHICLES.age'| translate}}
              <img class="whatsapp" style="width: 17px;position: relative; top: 3px;" (click)="sortVehicleAgeing()"
                [src]="vehicleAgeingSortIcon" alt="">
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.aging}} </td>
          </ng-container> -->

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'DEDICATED.action'| translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 60px;">
              <div class="action_item">
                <mat-icon class="more-icon" style="cursor: pointer;transform: rotate(90deg)"
                  [matMenuTriggerFor]="actions" (click)="$event.stopPropagation()">
                  more_vert</mat-icon>
              </div>
              <mat-menu #actions="matMenu">
                <button mat-menu-item *ngIf="enableEdit"
                  (click)="$event.stopPropagation();openAddObd(element)">{{'DEDICATED.edit' |
                  translate}}</button>
                <button mat-menu-item (click)="$event.stopPropagation();openRemark(element)">{{'DEDICATED.addRemark' |
                  translate}}</button>
                <button mat-menu-item (click)="$event.stopPropagation();openCancel(element)">{{'DEDICATED.cancel' |
                  translate}}</button>
              </mat-menu>

            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr mat-row *matRowDef="let row;let i=index; columns: displayedColumns;" 
          [ngClass]="{'highlightTableColor': selectedRowIndex == i}" (click)="getOrderStatus(row,i);">
          </tr>
        </table>
      </div>
      <mat-paginator fixed [length]="externalParkingvehicles ? totalvehicles : 0" [pageSize]="200"
        [pageSizeOptions]="[200, 400, 500]" [showFirstLastButtons]="true" (page)="pageNavigate($event)"
        style="margin-right: 14px;">
      </mat-paginator>
    </div>
  </div>
</div>
<ng-template #addObdDialog>
  <div class="obdDialog">
    <div class="dialog_header">
      <div class="dialog_title">{{selectedVehicle}}</div>
      <div class="dialog_close" (click)="obdDialogRef.close()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="dialog_body">
      <div class="left">
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="obdNumber" placeholder="ODB number" type="text">
        </div>
        <!-- <div class="input-container editInput">
            <input class="inputSelect" [(ngModel)]="shipperRemark" placeholder="Shipper Remark"
              type="text">
          </div> -->
        <div class="input-container editInput">
          <input type="text" class="formField" required="required" [matAutocomplete]="remarks"
            [(ngModel)]="shipperRemark" placeholder="Shipper Remarks" />
          <mat-autocomplete #remarks="matAutocomplete">
            <mat-option *ngFor="let reason of reasons | filter: shipperRemark" [value]="reason">
              <span>{{ reason }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="vehicleQty" placeholder="Vehicle Quantity" type="text">
        </div>
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="customer_name" placeholder="Customer Name" type="text">
        </div>
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="preferredLocation" placeholder="Customer Location" type="text">
        </div>
        <div class="input-container editInput">
          <input type="text" class="formField" required="required" [matAutocomplete]="orgPlace"
            [(ngModel)]="preferredZone" placeholder="Preferred Zone" />
          <mat-autocomplete #orgPlace="matAutocomplete">
            <mat-option *ngFor="let org of states | filter: preferredZone" [value]="org.name">
              <span>{{ org.name }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="right">
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="comment" placeholder="Comment" type="text">
        </div>
        <div class="input-container editInput">
          <input type="text" class="formField" required="required" [matAutocomplete]="car" [(ngModel)]="carrierUnit"
            placeholder="Carrier Unit" />
          <mat-autocomplete #car="matAutocomplete" (optionSelected)='selectCarrier($event.option.value)'>
            <mat-option *ngFor="let carrier of carriers | filter: carrierUnit" [value]="carrier.carrierName">
              <span>{{ carrier.carrierName }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="input-container editInput">
          <input class="inputSelect" [(ngModel)]="carrierType" placeholder="Carrier Type" type="text">
        </div>
        <div class="input-container editInput">
          <mat-select style="border: solid 1px #e3e3e3;height: 30px;  border-radius: 5px;   align-items: center;"
            multiple [(ngModel)]="registeredFor" class="formField">
            <mat-option *ngFor="let shipper of units;let i=index;" (onSelectionChange)="selectUnit(shipper, $event, i)"
              [value]="shipper.name">
              {{shipper.name}}
            </mat-option>
          </mat-select>
          <!-- <input type="text" class="formField" required="required" [matAutocomplete]="reg"
                [(ngModel)]="registeredFor" placeholder="Registered For" />
              <mat-autocomplete #reg="matAutocomplete" (optionSelected)='selectUnit($event.option.value)'>
                <mat-option *ngFor="let shipper of units | filter: registeredFor" [value]="shipper">
                  <span>{{ shipper.name }}</span>
                </mat-option>
              </mat-autocomplete> -->
        </div>
        <div class="input-container editInput">
          <div class="inputs">
            <div class="row" *ngFor="let row of materialLoadPairData;let i=index;">
              <div class="inputCons" style="display: flex;">
                <input type="text" [(ngModel)]="row.name" disabled="true">
                <div class="input">
                  <input type="text" [(ngModel)]="row.load">
                </div>
              </div>
            </div>
          </div>
          <!-- <input type="text" class="formField" required="required" [matAutocomplete]="material"
                [(ngModel)]="materialName" placeholder="Material" />
              <mat-autocomplete #material="matAutocomplete" (optionSelected)='selectRegisteredMaterial($event.option.value)'>
                <mat-option *ngFor="let material of registeredMaterials" [value]="material">
                  <span>{{ material.name }}</span>
                </mat-option>
              </mat-autocomplete> -->
        </div>
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="addObd()">{{'DEDICATED.submit'| translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #addRemarkDialog>
  <div class="dialog">
    <div class="dialog_header">
      <div class="dialog_title">{{'DEDICATED.addRemark'| translate}}</div>
      <div class="dialog_close" (click)="remarkDialogRef.close()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="dialog_body">
      <div class="input-container editInput">
        <input class="inputSelect" [(ngModel)]="remarks" placeholder="Add Remarks" type="text">
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="addObd()">{{'DEDICATED.submit'| translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #cancelDialog>
  <div class="dialog">
    <div class="dialog_header">
      <div class="dialog_title">{{'DEDICATED.cancel'| translate}} - {{vehicleNo}}</div>
      <div class="dialog_close" (click)="cancelDialogRef.close()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div style="width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    margin: 10px;
    border: solid 1px #e3e3e3;">
      <mat-select [(ngModel)]="cancelReason" placeholder="Cancel Reason">
        <mat-option *ngFor="let reason of cancelReasons" [value]="reason">
          {{reason}}
        </mat-option>
      </mat-select>
    </div>
    <div class="dialog_body" *ngIf="cancelReason === 'Other'">
      <div class="input-container editInput">
        <input class="inputSelect" [(ngModel)]="cancelReasonOther" type="text">
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="cancelVehicle()">{{'DEDICATED.submit'| translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #noData>
  <app-no-data></app-no-data>
</ng-template>